// extracted by mini-css-extract-plugin
export default {"-large":"panel-header-actions-module__-large--YydXO","closeButton":"panel-header-actions-module__closeButton--k5tG2","divider":"panel-header-actions-module__divider--f5qXT"};